// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isFunctionReturnAny(obj: unknown): obj is (...args: any) => any {
  return typeof obj === 'function';
}
